import React, { useState } from 'react';
import { getSiteName, getSiteInitial } from '../utils/theme';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-lunar-900/95 backdrop-blur-sm border-b border-[var(--primary-color-800-30)]">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
            <div className="w-8 h-8 bg-mystic-gradient rounded-full flex items-center justify-center">
              <span className="text-white font-elegant text-lg">{getSiteInitial()}</span>
            </div>
            <span className="text-2xl font-elegant font-bold text-white">{getSiteName()}</span>
          </a>



          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href={'https://cp.' + process.env.REACT_APP_SITE_URL + '/'}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 bg-mystic-gradient text-white rounded-lg hover:shadow-lg hover:shadow-mystic-500/25 transition-all duration-300 inline-block text-center"
            >
              Личный кабинет
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-[var(--primary-color-800-30)]">
            <nav className="flex flex-col space-y-4">
              <a 
                href={'https://cp.' + process.env.REACT_APP_SITE_URL + '/'}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2 bg-mystic-gradient text-white rounded-lg hover:shadow-lg hover:shadow-mystic-500/25 transition-all duration-300 text-left inline-block"
              >
                Личный кабинет
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;